import { render, staticRenderFns } from "./PriceHorses.vue?vue&type=template&id=66595ae4&"
import script from "./PriceHorses.vue?vue&type=script&lang=js&"
export * from "./PriceHorses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports